/**
 * Bootstraps all the relevant modules so that when included,
 *   the needed services, factories, etc., will have a defined module
 */

export default angular.module("routes:mapping", []).name;

require("../../../routes/mapping/services/mapping-modals");
require("../../../routes/mapping/controllers/truterritory");
require("../../../routes/mapping/services/mapping-modals");
require("../../../routes/mapping/services/has-map-access");

require("../../../routes/mapping/directives/download-image");
require("../../../routes/mapping/directives/history-slider");
require("../../../routes/mapping/directives/interval-slider");
require("../../../routes/mapping/directives/L.History-slider");
require("../../../routes/mapping/directives/layers");
require("../../../routes/mapping/directives/legend");
require("../../../routes/mapping/directives/map-reports");
require("../../../routes/mapping/directives/mapPermalink");
require("../../../routes/mapping/directives/sql-editor");
require("../../../routes/mapping/directives/truterritory-theme");
